import { useMemo } from 'react';
import { useUserContext } from '../providers/UserProvider';

const EMAIL_DOMAIN = '@cimplico.com';

/**
Checks if the given email address belongs to a staff member of the Cimplico organization.

@param email - The email address to check.
@returns true if the email address belongs to a staff member, false otherwise.
 */
function isStaffEmail(email: string): boolean {
    return email.endsWith(EMAIL_DOMAIN);
}

/**
 * React hook that returns whether the currently signed-in user is a staff member of the Cimplico organization.
 *
 * @returns true if the currently signed-in user is a staff member, false otherwise.
 */
export function useIsStaff(): boolean {
    const { email } = useUserContext();

    const isStaff = useMemo(() => isStaffEmail(email), [email]);

    return isStaff;
}
